module.exports = __webpack_public_path__ + "media/sv_se_s2_Caren.56cd33cd.oga";